module.exports = __webpack_public_path__ + "img/podium.74ff9247.png";